module.exports = __webpack_public_path__ + "img/logo.ef0dc315.png";